import { render, staticRenderFns } from "./Seal.vue?vue&type=template&id=deb2672e"
import script from "./Seal.vue?vue&type=script&lang=js"
export * from "./Seal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports